import { cloneElement } from "react";
import { clsx } from "./auth-service-tools193.js";
import { isElement } from "./auth-service-tools175.js";
import "./auth-service-tools177.js";
import { getRefProp } from "./auth-service-tools190.js";
import { useProps } from "./auth-service-tools225.js";
import { factory } from "./auth-service-tools248.js";
import { usePopoverContext } from "./auth-service-tools266.js";
import { useMergedRef } from "./auth-service-tools278.js";
const defaultProps = {
  refProp: "ref",
  popupType: "dialog"
};
const PopoverTarget = factory((props, ref) => {
  const {
    children,
    refProp,
    popupType,
    ...others
  } = useProps("PopoverTarget", defaultProps, props);

  if (!isElement(children)) {
    throw new Error("Popover.Target component children should be an element or a component that accepts ref. Fragments, strings, numbers and other primitive values are not supported");
  }

  const forwardedProps = others;
  const ctx = usePopoverContext();
  const targetRef = useMergedRef(ctx.reference, getRefProp(children), ref);
  const accessibleProps = ctx.withRoles ? {
    "aria-haspopup": popupType,
    "aria-expanded": ctx.opened,
    "aria-controls": ctx.getDropdownId(),
    id: ctx.getTargetId()
  } : {};
  return /*#__PURE__*/cloneElement(children, { ...forwardedProps,
    ...accessibleProps,
    ...ctx.targetProps,
    className: clsx(ctx.targetProps.className, forwardedProps.className, children.props.className),
    [refProp]: targetRef,
    ...(!ctx.controlled ? {
      onClick: ctx.onToggle
    } : null)
  });
});
PopoverTarget.displayName = "@mantine/core/PopoverTarget";
export { PopoverTarget };